import { DeprecatedApiService } from '@mode/legacy/data-access-model-js';
import { Resource } from '@mode/shared/util-halogen';

import { EasyIdentityResource } from '@mode/legacy/data-access-model-js';

export class IdentityEasyService {
  static $inject = ['ApiService'];
  constructor(private api: DeprecatedApiService) {}

  public parseEasyIdentityResponse(easyProvidersResponse) {
    return easyProvidersResponse.reduce((accumulator, provider) => ({ ...accumulator, [provider.id]: provider }), {});
  }

  public getEasyIdentityOptions(easyIdentityCollection: Resource) {
    return this.api
      .getResource(easyIdentityCollection, 'easy_identity_providers')
      .then((response) => this.parseEasyIdentityResponse(response));
  }

  public createKeyForUpdateParam(easyIdentityProvider: EasyIdentityResource) {
    if (easyIdentityProvider.id === 'password') {
      return `organization.organization_account.ident_${easyIdentityProvider.id}_enabled`;
    }
    return `organization.organization_account.ident_oauth_${easyIdentityProvider.id}_enabled`;
  }

  public updateEasyIdentityWithProvider(easyIdentityCollection: Resource, easyIdentityProvider: EasyIdentityResource) {
    const targetKey = this.createKeyForUpdateParam(easyIdentityProvider);
    const paramObj = {
      [targetKey]: !easyIdentityProvider.enabled,
    };
    return this.api.edit(easyIdentityCollection, paramObj);
  }
}
